import { fetcher } from "utils";

import { IMembersOrderPointsDetail } from "typings";

export const get__members__order_points__detail = (): Promise<IMembersOrderPointsDetail> =>
  fetcher.get("/members/order_points/detail");
